var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v("Subskrypcje emailowe")]),
      _c(
        "v-row",
        { attrs: { slot: "actions-prepend" }, slot: "actions-prepend" },
        [
          _c(
            "v-col",
            { attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Szukaj", "single-line": "" },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          "custom-filter": _vm.filterOverAllProperty,
          headers: _vm.headers,
          items: _vm.notificationResponse,
          loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false,
          search: _vm.search,
          expanded: _vm.expanded,
          "single-expand": ""
        },
        on: {
          "update:expanded": function($event) {
            _vm.expanded = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", { staticClass: "text-left" }, [
                    _c("h2", [_vm._v(_vm._s(props.item.name))])
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-left" },
                    [
                      _c(
                        "table",
                        _vm._l(props.item.notificationSubscriptions, function(
                          notificationSubscription
                        ) {
                          return _c(
                            "tr",
                            { key: notificationSubscription.id },
                            [
                              _c(
                                "td",
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.notificationEventTypes.find(
                                          function(v) {
                                            return (
                                              v.value ===
                                              notificationSubscription.type
                                            )
                                          }
                                        ).text
                                      ) +
                                      " "
                                  ),
                                  !!notificationSubscription.notify_after
                                    ? [
                                        _c("br"),
                                        _vm._v(
                                          " Powiadom po: " +
                                            _vm._s(
                                              notificationSubscription.notify_after.replace(
                                                "+",
                                                ""
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    : _vm._e(),
                                  !!notificationSubscription.repeat_notify_after
                                    ? [
                                        _c("br"),
                                        _vm._v(
                                          " Powtarzaj po: " +
                                            _vm._s(
                                              notificationSubscription.repeat_notify_after.replace(
                                                "+",
                                                ""
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              ),
                              _c("td", [
                                _vm._v(_vm._s(notificationSubscription.email))
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(notificationSubscription.subject_mask)
                                )
                              ]),
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.$store.getters["Ajax/loading"],
                                        icon: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.remove(
                                            notificationSubscription.id
                                          )
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("delete")])],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      props.item.notificationSubscriptions.length === 0
                        ? _c(
                            "v-chip",
                            { attrs: { color: "red", outlined: "" } },
                            [_vm._v("Brak notyfikacji mailowych")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "td",
                    [
                      _vm.selectedCompany === props.item.id
                        ? _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function($event) {
                                  _vm.expanded.splice(
                                    _vm.expanded.indexOf(props.item),
                                    1
                                  )
                                  _vm.selectedCompany = null
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("expand_less")])],
                            1
                          )
                        : _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function($event) {
                                  return _vm.openEditRow(props)
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("expand_more")])],
                            1
                          )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "expanded-item",
            fn: function(props) {
              return [
                _c(
                  "td",
                  { attrs: { colspan: "100%" } },
                  [
                    _c(
                      "v-form",
                      { ref: "form", attrs: { lazy: "" } },
                      [
                        _c(
                          "v-row",
                          { staticClass: "px-3" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "px-3",
                                staticStyle: { "padding-top": "20px" }
                              },
                              [
                                _c(
                                  "span",
                                  [_c("v-icon", [_vm._v("fa-arrow-up")])],
                                  1
                                )
                              ]
                            ),
                            _c("v-autocomplete", {
                              attrs: {
                                items: _vm.notificationEventTypes,
                                rules: [
                                  function(v) {
                                    return (
                                      v != null ||
                                      _vm.$t("global.error.required")
                                    )
                                  }
                                ],
                                label: "Typ zdarzenia*"
                              },
                              model: {
                                value: _vm.selectedType,
                                callback: function($$v) {
                                  _vm.selectedType = $$v
                                },
                                expression: "selectedType"
                              }
                            }),
                            _c("v-text-field", {
                              staticClass: "mx-3",
                              attrs: { rules: _vm.emailRules, label: "Email*" },
                              model: {
                                value: _vm.selectedEmail,
                                callback: function($$v) {
                                  _vm.selectedEmail = $$v
                                },
                                expression: "selectedEmail"
                              }
                            }),
                            _c("br"),
                            _c("v-text-field", {
                              staticClass: "mx-3",
                              attrs: {
                                "append-outer-icon": "fa-info-circle",
                                label: "Maska tematu"
                              },
                              on: {
                                "click:append-outer": function($event) {
                                  return _vm.openDialogInfo(props.item.id)
                                }
                              },
                              model: {
                                value: _vm.selectedSubjectMask,
                                callback: function($$v) {
                                  _vm.selectedSubjectMask = $$v
                                },
                                expression: "selectedSubjectMask"
                              }
                            }),
                            _c(
                              "v-btn",
                              {
                                staticClass: "success mt-4",
                                attrs: {
                                  disabled: _vm.$store.getters["Ajax/loading"]
                                },
                                on: { click: _vm.add }
                              },
                              [_vm._v("Dodaj")]
                            )
                          ],
                          1
                        ),
                        _vm.selectedType !== null &&
                        _vm.notificationEventTypes.find(function(v) {
                          return v.value === _vm.selectedType
                        }).dates
                          ? _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "px-3",
                                    attrs: { cols: "12", md: "6" }
                                  },
                                  [
                                    _c("php-date-diff-chooser", {
                                      attrs: {
                                        value: _vm.selectedNotifyAfter,
                                        label: "Powiadom po",
                                        "can-be-disabled": false
                                      },
                                      on: {
                                        "update:value": function($event) {
                                          _vm.selectedNotifyAfter = $event
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "px-3",
                                    attrs: { cols: "12", md: "6" }
                                  },
                                  [
                                    _c("php-date-diff-chooser", {
                                      attrs: {
                                        value: _vm.repeatNotifyAfter,
                                        label: "Powtarzaj co",
                                        "can-be-disabled": true
                                      },
                                      on: {
                                        "update:value": function($event) {
                                          _vm.repeatNotifyAfter = $event
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c("v-divider")
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v("Lista dostępnych tagów")
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c("b", [_vm._v("{STANDARD}")]),
                  _vm._v(" - standardowy temat wiadomości z systemu "),
                  _c("br"),
                  _c("b", [_vm._v("{ID}")]),
                  _vm._v(" - unikalny identyfikator zamówienia "),
                  _c("br"),
                  _c("b", [_vm._v("{CREATED_AT}")]),
                  _vm._v(" - data złożenia zamówienia "),
                  _c("br"),
                  _c("b", [_vm._v("{CREATED_BY}")]),
                  _vm._v(" - Imię i nazwisko osoby zamawiającej "),
                  _c("br"),
                  _c("b", [_vm._v("{PRICE}")]),
                  _vm._v(
                    " - w przypadku wybranej oferty suma cen zamawianych usług "
                  ),
                  _c("br"),
                  _vm._v(" {ATTRIBUTE:["),
                  _c(
                    "span",
                    {
                      staticStyle: { "text-decoration": "#0f0f0f line-through" }
                    },
                    [_vm._v("example")]
                  ),
                  _vm._v(
                    "]} - w przypadku ustawienia dodatkowych parametrów możliwe jest użycie także tych parametrów w temacie wiadomości "
                  ),
                  _c("br"),
                  _vm._l(_vm.additionalParameters, function(parameter) {
                    return _c("span", { key: parameter.id }, [
                      _c("b", [
                        _vm._v("{ATTRIBUTE:[" + _vm._s(parameter.name) + "]}")
                      ]),
                      _vm._v(" "),
                      _c("br")
                    ])
                  })
                ],
                2
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }